import React, { PureComponent } from "react";
import { useSwipeable } from "react-swipeable";
import { EpubView } from "./EpubView";
import { EpubReaderStyles } from "./EpubReader.styles";
import { IEpubReaderStyles, IEpubViewProps, IEpubViewStyles } from "./Types";
import "../../Styles/Home.css";

import {
  ConfigurationOptions,
  SwipeableCallbacks,
} from "react-swipeable/es/types";
import { IToc } from ".";

interface ISwipeable
  extends Partial<SwipeableCallbacks & ConfigurationOptions> {
  children: any;
}
const Swipeable = ({ children, ...props }: ISwipeable) => {
  const handlers = useSwipeable(props);
  return <div {...handlers}>{children}</div>;
};

// ==================== TOC ITEM ====================

interface ITocItemProps {
  label: string;
  labeltwo?: string;
  href: string;
  setLocation: Function;
  styles?: any;
  subitems?: any[];
  onTocSelect?: (label: any, subLabel?: any) => void;
  activeHref?: string | null;
  setSaveSubHead: (label: any) => void;
}

interface ITocItemState {
  expandedPaths: Set<string>;
  activeItemId: string | null;
}

class TocItem extends PureComponent<ITocItemProps, ITocItemState> {
  state: ITocItemState = {
    expandedPaths: new Set<string>(),
    activeItemId: null,
  };

  // toggleExpansion = (href: string) => {
  //   this.setState((prev) => {
  //     const newSet = new Set(prev.expandedPaths);
  //     if (newSet.has(href)) {
  //       newSet.delete(href);
  //     } else {
  //       newSet.add(href);
  //     }
  //     return { expandedPaths: newSet };
  //   });
  // };

  toggleExpansion = (href: string, subitems: any[] = []) => {
  this.setState((prev) => {
    const newSet = new Set(prev.expandedPaths);

    if (newSet.has(href)) {
      // ------------ COLLAPSING ------------
      newSet.delete(href);

      const collapseChildren = (items: any[]) => {
        items.forEach((item) => {
          if (newSet.has(item.href)) {
            newSet.delete(item.href);
          }
          if (item.subitems && item.subitems.length > 0) {
            collapseChildren(item.subitems);
          }
        });
      };

      collapseChildren(subitems);
    } else {
      // ------------ EXPANDING ------------
      newSet.add(href);
    }

    return { expandedPaths: newSet };
  });
};


  isExpanded = (href: string): boolean => {
    return this.state.expandedPaths.has(href);
  };

  notifySelection = (href: string, parentLabel: string, subLabel?: string) => {
    this.setState({ activeItemId: href });
    this.props.setLocation(href, parentLabel || "", subLabel || "");
    if (this.props.onTocSelect) {
      this.props.onTocSelect(parentLabel, subLabel ?? null);
    }
  };

  onParentClick = (
    e: React.MouseEvent,
    href: string,
    label: string,
    hasSub: boolean,
    subitems: any[] = []
  ) => {
    e.preventDefault();
    if (hasSub) {
      // this.toggleExpansion(href);
      this.toggleExpansion(href,subitems)
    }
    this.notifySelection(href, label);
  };

  onSubItemClick = (e: React.MouseEvent, parentLabel: string, sub: any) => {
    e.preventDefault();
    const href = sub.href;
    const subLabel = sub.label;
    this.setState({ activeItemId: href });
    this.props.setSaveSubHead(subLabel);
    this.notifySelection(href, parentLabel, subLabel);
  };

  onSubSubItemClick = (
    e: React.MouseEvent,
    parentLabel: string,
    subLabel: string,
    subsub: any
  ) => {
    e.preventDefault();
    const href = subsub.href;
    this.setState({ activeItemId: href });
    this.props.setSaveSubHead(subLabel);
    this.notifySelection(href, parentLabel, subLabel);
  };

  render() {
    const { label, subitems = [], href } = this.props;
    const hasSubitems = Array.isArray(subitems) && subitems.length > 0;
    const parentExpanded = this.isExpanded(href);

    return (
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid #ddd",
          width: "90%",
          margin: hasSubitems ? "0 10px 0 0" : "0 0 0 10px",
        }}
      >
        <span
          style={{
            fontSize: 25,
            cursor: "pointer",
            color: "#ff4900",
            fontWeight: 600,
            padding: 0,
            userSelect: "none",
          }}
          onClick={(e) => {
            if (hasSubitems) {
              e.preventDefault();
              this.toggleExpansion(href);
            }
          }}
        >
          {hasSubitems ? (parentExpanded ? "-" : "+") : ""}
        </span>

        <div style={{ width: "100%" }}>
          <div>
            <div
              id="titlename"
              onClick={(e) => this.onParentClick(e, href, label, hasSubitems)}
              className={`list-item-label ${
                this.props.activeHref === href ? "active" : ""
              }`}
              style={{
                userSelect: "none",
                appearance: "none",
                background: "none",
                border: "none",
                display: "block",
                width: "100%",
                textAlign: "left",
                padding: "0 0 0 10px",
                boxSizing: "border-box",
                outline: "none",
                cursor: "pointer",
                fontSize: 20,
                fontFamily: "ChanakyaUni, serif",
                margin: hasSubitems ? "0 10px 0 0" : "0 0 0 10px",
              }}
            >
              {label}
            </div>
          </div>

          <div>
            {subitems?.map((subitem: any, index: number) => {
              const showSub = parentExpanded;
              const subExpanded = this.isExpanded(subitem.href);

              return (
                <div key={`sub-${index}`}>
                  <div
                    className={`list-item ${
                      this.props.activeHref === subitem?.href ? "active" : ""
                    }`}
                    style={{
                      display: showSub ? "flex" : "none",
                      userSelect: "none",
                      appearance: "none",
                      background: "none",
                      borderBottom: "1px solid #ddd",
                      textAlign: "left",
                      boxSizing: "border-box",
                      outline: "none",
                      cursor: "pointer",
                      fontSize: "20px",
                      fontFamily: "ChanakyaUni, serif",
                      width: "130%",
                    }}
                  >
                    <span
                      style={{
                        fontSize: 25,
                        cursor: "pointer",
                        color: "#ff4900",
                        fontWeight: 600,
                        padding: 0,
                        marginRight: "10px",
                        userSelect: "none",
                      }}
                      onClick={(e) => {
                        if (subitem?.subitems && subitem.subitems.length > 0) {
                          e.preventDefault();
                          this.toggleExpansion(subitem.href,subitem.subitems);
                        }
                      }}
                    >
                      {subitem?.subitems?.length > 0
                        ? subExpanded
                          ? "-"
                          : "+"
                        : ""}
                    </span>

                    <p
                      id="subLabel"
                      style={{ margin: "0", padding: "0", userSelect: "none" }}
                      onClick={(e) => this.onSubItemClick(e, label, subitem)}
                    >
                      {subitem?.label}
                    </p>
                  </div>

                  {/* Sub-sub items */}
                  {subitem?.subitems?.length > 0 &&
                    subitem.subitems.map((subsub: any, subindex: number) => {
                      const showSubSub = subExpanded;
                      return (
                        <div
                          key={`subsub-${subindex}`}
                          onClick={(e) =>
                            this.onSubSubItemClick(
                              e,
                              label,
                              subitem.label,
                              subsub
                            )
                          }
                          id="subLabeloflabel"
                          className={`listsubitem ${
                            this.props.activeHref === subsub?.href ? "active" : ""
                          }`}
                          style={{
                            display: showSubSub ? "block" : "none",
                            userSelect: "none",
                            background: "none",
                            borderBottom: "1px solid #ddd",
                            textAlign: "left",
                            padding: "5px 0px 0px 5px",
                            boxSizing: "border-box",
                            outline: "none",
                            cursor: "pointer",
                            fontSize: "20px",
                            fontFamily: "ChanakyaUni, serif",
                            width: "130%",
                          }}
                        >
                          {subsub?.label}
                        </div>
                      );
                    })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

// ==================== EPUB READER ====================

interface IEpubReaderProps extends Omit<IEpubViewProps, "styles"> {
  title?: string;
  showToc?: boolean;
  styles?: IEpubReaderStyles;
  swipeable?: boolean;
  epubViewStyles?: IEpubViewStyles;
  setSaveSubHead?: any;
}

interface IEpubReaderState {
  expandedToc: boolean;
  toc: any[];
  activeHref?: string | null;
}

export class EpubReader extends PureComponent<
  IEpubReaderProps,
  IEpubReaderState
> {
  readerRef: React.RefObject<EpubView | null>;

  constructor(props: IEpubReaderProps) {
    super(props);
    this.readerRef = React.createRef();
    this.state = {
      expandedToc: false,
      toc: [],
    };
  }

  toggleToc = () => {
    this.setState({
      expandedToc: !this.state.expandedToc,
    });
  };

  onTocChange = (toc: IToc) => {
    const { tocChanged } = this.props;
    this.setState(
      {
        toc: [toc],
      },
      () => tocChanged && tocChanged(toc)
    );
  };

  componentDidMount() {
    console.log("EpubReader mounted");
  }

  componentDidUpdate(prevProps: IEpubReaderProps) {
    if (this.props.location !== prevProps.location) {
      console.log("Location changed.");
    }
  }

  componentWillUnmount() {
    console.log("EpubReader will unmount");
  }

  setLocation = (
    loc: string | number,
    title: string = "",
    sub: string = ""
  ) => {
    const { locationChanged, heading, subHeading, setSaveSubHead } = this.props;
    console.log("Setting Location:", loc);
    locationChanged && locationChanged(loc);
    subHeading && subHeading(sub || title);
    heading && heading(title);
    setSaveSubHead && setSaveSubHead(sub || "");
    this.setState({ activeHref: loc as string });
  };

  renderToc() {
    const { toc, expandedToc } = this.state;
    const { styles = EpubReaderStyles } = this.props;
    return (
      <div
        id="tocwidth"
        style={Object.assign(
          {},
          styles.tocArea,
          expandedToc ? styles.tocAreaWidth : { width: "0px" }
        )}
      >
        <div className="container">
          <div style={styles.toc}>
            {toc?.length > 0 &&
              toc[0].map((item: any, i: number) => {
                return (
                  <TocItem
                    {...item}
                    key={item.Id ?? i}
                    setLocation={this.setLocation}
                    subitems={item.subitems}
                    onTocSelect={this.props.onTocSelect}
                    activeHref={this.state.activeHref}
                    setSaveSubHead={this.props.setSaveSubHead || (() => {})}
                  />
                );
              })}
          </div>
        </div>
        {expandedToc && (
          <div style={styles.tocBackground} onClick={this.toggleToc} />
        )}
      </div>
    );
  }

  next = () => {
    this.readerRef.current?.nextPage();
    this.props.setSaveSubHead?.("");
    this.setState({ expandedToc: false });
  };

  prev = () => {
    this.readerRef.current?.prevPage();
    this.props.setSaveSubHead?.("");
  };

  renderTocToggle() {
    const { expandedToc } = this.state;
    const { styles = EpubReaderStyles } = this.props;
    return (
      <button
        style={Object.assign(
          {},
          styles.tocButton,
          expandedToc ? styles.tocButtonExpanded : {}
        )}
        onClick={this.toggleToc}
      >
        {!expandedToc ? (
          <div>
            <span
              style={Object.assign(
                {},
                styles.tocButtonBar,
                styles.tocButtonBarTop,
                { width: "25px", height: "3px", backgroundColor: "white" }
              )}
            />
            <span
              style={Object.assign(
                {},
                styles.tocButtonBar,
                {
                  width: "20px",
                  height: "3px",
                  backgroundColor: "white",
                }
              )}
            />
            <span
              style={Object.assign(
                {},
                styles.tocButtonBar,
                styles.tocButtonBottom,
                { width: "25px", height: "3px", backgroundColor: "white" }
              )}
            />
          </div>
        ) : (
          <button className="icon-close" style={{ marginTop: "14px" }} />
        )}
      </button>
    );
  }

  render() {
    const {
      title,
      showToc = true,
      loadingView = <div style={EpubReaderStyles.loadingView}>Loading…</div>,
      styles = EpubReaderStyles,
      locationChanged,
      swipeable,
      epubViewStyles,
      ...props
    } = this.props;
    const { toc, expandedToc } = this.state;

    return (
      <>
        <div style={styles.container}>
          <div style={styles.titleArea}>{title}</div>
          <div
            id="test-div"
            style={Object.assign(
              {},
              styles.readerArea,
              expandedToc ? styles.containerExpanded : {}
            )}
          >
            {showToc && this.renderTocToggle()}

            <Swipeable
              onSwipedRight={this.prev}
              onSwipedLeft={this.next}
              trackMouse
            >
              <div style={styles.reader}>
                <EpubView
                  ref={this.readerRef}
                  loadingView={loadingView}
                  styles={epubViewStyles}
                  {...props}
                  tocChanged={this.onTocChange}
                  locationChanged={locationChanged}
                />
                {swipeable && <div style={styles.swipeWrapper} />}
              </div>
            </Swipeable>
            <button
              style={Object.assign({}, styles.arrow, styles.prev)}
              onClick={this.prev}
            >
              ‹
            </button>
            <button
              style={Object.assign({}, styles.arrow, styles.next)}
              onClick={this.next}
            >
              ›
            </button>
          </div>
          {showToc && toc && this.renderToc()}
        </div>
      </>
    );
  }
}